import { Outlet, useOutletContext } from '@remix-run/react'
import * as React from 'react'

import { type Context } from '~/routes/_layout/root.component'
import { Box } from '@radix-ui/themes'

/* -------------------------------------------------------------------------------------------------
 * Component
 * -----------------------------------------------------------------------------------------------*/

const Component: React.FC = () => (
  <Box mt="6rem">
    <Outlet context={useOutletContext<Context>()} />
  </Box>
)
Component.displayName = 'Component'

/* -----------------------------------------------------------------------------------------------*/

export { Component }
